export default {
    title: '核稿審查',
    noSessions: '暫無審查記錄',
    noSessionsHint: '執行核稿工具後，結果將顯示在此處',
    rules: '條規則',
    loadFailed: '載入失敗，請重試',
    view: {
        issues: '問題列表',
        patent: '專利原文',
    },
    filter: {
        all: '全部',
        critical: '嚴重',
        error: '錯誤',
        warning: '警告',
        pass: '通過',
    },
    issue: {
        ignore: '忽略',
        ignored: '已忽略',
        applied: '已處理',
        pending: '待處理',
        expired: '已過期',
        ignoreSuccess: '已忽略',
        ignoreFailed: '操作失敗',
    },
    passCollapsed: '通過 ({count} 條)',
    expand: '展開',
    collapse: '收起',
    uncategorized: '未分類',
    noIssuesInSection: '此部分暫無問題',
    patent: {
        loading: '載入中...',
        loadError: '載入失敗，請重試',
        noContent: '暫無內容',
        background: '背景技術',
        description: '發明內容',
    },
    field: {
        location: '位置',
        description: '問題描述',
        suggestion: '修改建議',
        oldContent: '原文',
        newContent: '修改後',
        source: '依據來源',
    },
    section: {
        abstract: '摘要',
        claims: '申請專利範圍',
        title: '標題',
        specification: '說明書',
    },
    taskRunning: '目前有任務正在執行，請等待任務完成後再開始核稿',
    newReview: '新增核稿',
    selectDocument: '選擇文件',
    noDocuments: '暫無文件',
    reviewPrompt: '使用核稿審查工具進行核稿',
    backToList: '返回列表',
    startReview: '開始核稿',
    words: '字',
    tab: {
        review: '核稿審查',
        rules: '規則管理',
    },
    customRules: {
        loadFailed: '載入規則失敗，請重試',
        createSuccess: '規則建立成功',
        createFailed: '規則建立失敗',
        updateSuccess: '規則更新成功',
        updateFailed: '規則更新失敗',
        deleteSuccess: '規則刪除成功',
        deleteFailed: '規則刪除失敗',
        create: '新建規則',
        searchPlaceholder: '搜尋規則...',
        edit: '編輯',
        delete: '刪除',
        deleteConfirm: '確認刪除此規則？',
        confirmYes: '確認',
        confirmNo: '取消',
        empty: '暫無自訂規則',
        systemEmpty: '暫無系統規則',
        systemBadge: '系統',
        viewMy: '我的規則',
        viewSystem: '系統規則',
        col: {
            ruleId: '規則ID',
            patentOffice: '專利局',
            category: '分類',
            severity: '嚴重程度',
            description: '描述',
            message: '提示訊息',
            status: '狀態',
            createdAt: '建立時間',
            actions: '操作',
        },
        filter: {
            patentOffice: '專利局',
            category: '分類',
            status: '狀態',
            enabled: '已啟用',
            disabled: '已停用',
        },
        category: {
            claims: '申請專利範圍',
            abstract: '摘要',
            title: '標題',
            specification: '說明書',
            drawing_description: '圖式說明',
            invention_content: '發明內容',
            field: '技術領域',
            punctuation: '標點符號',
            implementation: '具體實施方式',
            background: '背景技術',
            figures: '附圖',
        },
        severity: {
            error: '錯誤',
            warning: '警告',
            info: '提示',
        },
        field: {
            patentOffice: '專利局',
            category: '分類',
            severity: '嚴重程度',
            description: '規則描述',
            descriptionPlaceholder: '例：背景技術應客觀描述相關現有技術',
            message: '提示訊息',
            messagePlaceholder: '例：背景技術描述不符合要求',
            suggestion: '修改建議',
            suggestionPlaceholder: '例：客觀描述相關現有技術，指出本發明要解決的技術問題',
            requirement: '規則要求',
            requirementPlaceholder: '例：\n寫明對發明的理解、檢索、審查有用的背景技術\n客觀指出背景技術中存在的問題和缺點\n只指出本發明要解決的問題和缺點',
            requirementHint: '每行一條要求',
        },
        drawer: {
            titleCreate: '新建規則',
            titleEdit: '編輯規則',
            cancel: '取消',
            submit: '儲存',
            submitting: '儲存中...',
        },
        validation: {
            required: '此項為必填',
        },
    },
};
